module.exports = __webpack_public_path__ + "img/service1-05.7e177e61.png";